"use strict";

const mode = {
  ADD: "ADD",
  EDIT: "EDIT",
};

export default mode;
